<template>
  <ApprovalsFlowDetailPending
    v-if="activeFlow?.status === 'pending'"
    :initial-show-started-banner="initialShowStartedBanner"
  />
  <ApprovalsFlowDetailHistorical
    v-else-if="activeFlow"
  />
</template>

<script setup>
import { storeToRefs } from 'pinia';
import ApprovalsFlowDetailHistorical from '@/components/jobProfiles/editor/approvals/ApprovalsFlowDetailHistorical.vue';
import ApprovalsFlowDetailPending from '@/components/jobProfiles/editor/approvals/ApprovalsFlowDetailPending.vue';
import { useApprovalFlows } from '@/stores/jobProfiles/approvalFlows';

defineProps({
  initialShowStartedBanner: {
    type: Boolean,
    default: false,
  },
});

const { activeFlow } = storeToRefs(useApprovalFlows());
</script>
